import { render } from "./Product_List_Item.vue?vue&type=template&id=da8a8d4e&scoped=true"
import script from "./Product_List_Item.vue?vue&type=script&lang=js"
export * from "./Product_List_Item.vue?vue&type=script&lang=js"

import "./Product_List_Item.vue?vue&type=style&index=0&id=da8a8d4e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da8a8d4e"]])

export default __exports__